import React from 'react';

const BSNPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/bsn',
			exact: true,
			component: React.lazy(() => import('./BSNPage')),
		},
	],
};

export default BSNPageConfig;
